import React from 'react';
import OrderList from './src-components-AdvanceMessagingComponent-OrderList-OrderList.js';
import ProductList from './src-components-AdvanceMessagingComponent-ProductList-ProductList.js';
import { util } from './src-utils-miaw-common.js';
import { DISPLAY_NAME } from './src-config-app-config.js';
import ButtonGroup from './src-components-AdvanceMessagingComponent-ButtonGroup-ButtonGroup.js';
import { getChatbotSessionInfo } from './src-utils-chatbot-api-utils.js';
import NonLoggedInOrderForm from './src-components-NonLoggedInOrderForm-NonLoggedInOrderForm.js';

const defaultURLMapping = {
  "Track Order,": "https://www.vistaprint.ca/oh/",
  "Get design support,": "https://www.vistaprint.ca/design",
  "Visit Help Center.": "https://www.vistaprint.ca/customer-care/help-centre/"
};
const getAgentButton = () => {
  return /* @__PURE__ */ React.createElement(ButtonGroup, { actionList: [{ label: "Chat with a specialist", value: "agentConnect" }], type: "buttons" });
};
const tranferToAgent = (typeOfFLow) => {
  return /* @__PURE__ */ React.createElement(ButtonGroup, { actionList: [], type: "buttons", typeOfFLow });
};
const showAgentButton = (data) => {
  let showButton = false;
  if (data.toLowerCase().includes("specialist") || data.toLowerCase().includes("agent")) {
    showButton = true;
  }
  if (data.toLowerCase().includes("offline")) showButton = false;
  return showButton;
};
const getMessageList = (data, responseURLMapping) => {
  let showButton = false;
  const messageList = [];
  const urlMapping = [];
  const customMessage = "Would you like to chat with a specialist?";
  data.forEach((msg) => {
    const matchedKeys = Object.keys(defaultURLMapping).filter((key) => msg?.toLowerCase().includes(key.toLowerCase()));
    if (matchedKeys.length > 0) {
      let replacedMsg = msg;
      matchedKeys.forEach((matchedKey) => {
        const regex = new RegExp(matchedKey, "ig");
        replacedMsg = replacedMsg.replace(regex, `
${defaultURLMapping[matchedKey]}`);
        urlMapping.push({
          url: defaultURLMapping[matchedKey],
          label: matchedKey
        });
      });
      messageList.push(replacedMsg);
      return;
    }
    let updatedMsg = msg;
    responseURLMapping?.forEach((item) => {
      if (msg.toLowerCase().includes(item.label.toLowerCase())) {
        const escapedLabel = item.label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(escapedLabel, "ig");
        updatedMsg = updatedMsg.replace(regex, item.url);
      }
    });
    if (updatedMsg.toLowerCase().includes("specialist") || updatedMsg.toLowerCase().includes("agent")) {
      showButton = true;
    }
    if (updatedMsg.toLowerCase().includes("offline")) showButton = false;
    if (updatedMsg === "SPECIALIST CONNECTED") {
      messageList.push(customMessage);
    } else {
      updatedMsg = updatedMsg.replace(/You can track it here:/g, "").trim();
      if (updatedMsg.includes("[Non-Logged In User] -- ")) {
        updatedMsg = updatedMsg.replace("[Non-Logged In User] -- ", "").trim();
      }
      messageList.push(updatedMsg);
    }
  });
  return { updatedMessageList: messageList, showAgent: showButton, urlMapping };
};
const transformChatbotResponse = (fetchedData, msgId, timestamp, isRetrivedData = false, isLastMessage = false) => {
  let message;
  const messageType = fetchedData.response?.data?.type;
  if (messageType) {
    switch (messageType) {
      case "order_list":
        if (fetchedData.response.data.is_guest_customer) {
          message = handleNonLoggedInOrderTrackingResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        } else {
          message = handleOrderResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        }
        break;
      case "user_sub_intent":
      case "user_intent":
        message = handleIntentResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "money_back_mode":
        message = handleMoneyBackResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "products_cancellable_status":
        if (fetchedData.response.data.is_guest_customer && fetchedData.response.data.intent === "request cancellation") {
          message = handleNonLoggedInOrderTrackingResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        } else {
          message = handleCancelOrderProductsResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        }
        break;
      case "product_list":
        message = handleOrderProductsResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "product_tracking":
        message = handleProductTrackingResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "cancellation_confirmation":
        message = handleCancelConfirmationResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "escalate_to_agent":
        message = handleSpecialistEscalation(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
      case "text_message":
      default:
        message = handleGenericMessageResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
        break;
    }
  } else {
    message = handleGenericMessageResponse(fetchedData, timestamp, isRetrivedData, isLastMessage);
  }
  message = { ...message, id: fetchedData?.message_id || msgId };
  return [message];
};
const currencyMapping = {
  AUD: "$",
  CAD: "$",
  EUR: "\u20AC",
  GBP: "\xA3",
  SGD: "$",
  USD: "$",
  NZD: "$"
};
const getPrice = (price) => {
  const value = price.centAmount / Math.pow(10, price.fractionDigits);
  return `${currencyMapping[price.currencyCode] || price.currencyCode}${value}`;
};
const getOrderList = (data) => {
  const orderList = data.response?.data?.orders?.map((order) => ({
    orderId: order.orderNumber,
    orderNumber: order.orderNumber,
    orderDate: new Date(order.orderCreationDate).getTime(),
    displayPrice: getPrice(order.orderTotal),
    orderItems: order.product_urls.map((url) => ({ itemId: url.label, imageUrl: url.url }))
  }));
  return orderList;
};
const handleIntentResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const intents = data.response?.data?.intents;
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (intents.length > 0 ? /* @__PURE__ */ React.createElement(
      ButtonGroup,
      {
        actionList: intents.map((int) => {
          return { label: int, value: int };
        }),
        postion: "end",
        type: "buttons"
      }
    ) : showAgent ? getAgentButton() : void 0),
    urlMapping,
    customMessageType: "orderIntentResponseMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleMoneyBackResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const moneyBackModes = data?.response?.data?.money_back_modes;
  const is_remediation_available = data?.response?.data?.is_remediation_available;
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  const hasMoneyOptionNotAvailable = moneyBackModes.some((item) => item.is_option_available === false);
  if (hasMoneyOptionNotAvailable) {
    updatedMessageList.push("**Note:** Some options may not be available if you\u2019ve already made a request or because of your payment method.");
  }
  const message = {
    id: util.generateUUID(),
    messageContent: is_remediation_available == false ? "Thank you! I\u2019ll connect you with a specialist to review your case and help resolve it." : updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (!is_remediation_available ? tranferToAgent("transferToAgent") : moneyBackModes.length ? /* @__PURE__ */ React.createElement(
      ButtonGroup,
      {
        actionList: moneyBackModes.map((item) => {
          return { label: item.label, description: item.description, value: item.label, isOptionAvailable: item.is_option_available };
        }),
        postion: "start",
        type: "tiles-horizontal",
        typeOfFLow: "moneyBack"
      }
    ) : showAgent ? getAgentButton() : void 0),
    urlMapping,
    customMessageType: "moneyBackModeMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleSpecialistEscalation = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const message = {
    id: util.generateUUID(),
    messageContent: "Thank you! I\u2019ll connect you with a specialist to review your case and help resolve it.",
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && tranferToAgent("transferToAgent"),
    customMessageType: "escalationResponse",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleCancelOrderProductsResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const productItem = data?.response?.data?.products?.map((product) => ({
    name: product.productName,
    displayPrice: getPrice(product.totalDiscountedPrice),
    itemId: product.productId,
    imagURL: product.livePreviewUrl,
    is_cancellable: product.is_cancellable,
    status: product.status ?? "In production"
  }));
  let messages = data?.response?.messages;
  const isProductNotEligibleForCancellation = data?.response?.data?.is_products_not_eligible_for_cancellation || data.response.data.is_order_not_cancellable;
  if (isProductNotEligibleForCancellation) {
    messages = [
      `I'm sorry, but none of the products in this order can be cancelled because they've already been shipped or delivered.`,
      `Is there anything else I can help with?`
    ];
  }
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(messages, data.response?.data?.urls);
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (productItem.length > 0 && !isProductNotEligibleForCancellation ? /* @__PURE__ */ React.createElement(ProductList, { items: productItem, orderId: data.response.data.orderID, sender: "chatbot", isCancellationFlow: true }) : showAgent ? getAgentButton() : void 0),
    urlMapping,
    customMessageType: "productListMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleCancelConfirmationResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && showAgent ? getAgentButton() : /* @__PURE__ */ React.createElement(
      ButtonGroup,
      {
        actionList: [
          { label: "No, thank you", value: "No, thank you" },
          { label: "Yes", value: "Yes" }
        ],
        type: "buttons"
      }
    ),
    urlMapping,
    customMessageType: "orderOptionsMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleOrderResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const orderList = getOrderList(data);
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (orderList.length > 0 ? /* @__PURE__ */ React.createElement(OrderList, { orders: orderList, ordersCount: data.response.data.total_orders, sender: "chatbot" }) : showAgent ? getAgentButton() : void 0),
    urlMapping,
    customMessageType: "orderListMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleOrderProductsResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const productItem = data?.response?.data?.products?.map((product) => ({
    name: product.productName,
    displayPrice: getPrice(product.totalDiscountedPrice),
    itemId: product.productId,
    imagURL: product.livePreviewUrl
  }));
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (productItem.length > 0 ? /* @__PURE__ */ React.createElement(ProductList, { items: productItem, orderId: data.response.data.orderID, sender: "chatbot" }) : showAgent ? getAgentButton() : void 0),
    urlMapping,
    customMessageType: "productListMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleProductTrackingResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const { updatedMessageList, showAgent, urlMapping } = getMessageList(data?.response?.messages, data.response?.data?.urls);
  let updatedURLMapping = [];
  const trackingInfo = data?.response?.data?.tracking_info;
  if (urlMapping.length > 0) {
    updatedURLMapping = [...urlMapping];
  }
  trackingInfo?.forEach((info) => {
    info?.fulfillmentData?.forEach((fulfillment) => {
      fulfillment?.urls?.forEach((url) => {
        updatedURLMapping.push({ label: url.label, url: url.url });
      });
    });
  });
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    isMessageRead: timestamp ? true : false,
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    urlMapping: updatedURLMapping,
    additionalComponents: (!isRetrivedData || isLastMessage) && (showAgent ? getAgentButton() : void 0),
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleGenericMessageResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  let messageContent = "";
  if (typeof data.response === "string") messageContent = data?.response;
  const { showAgent, updatedMessageList, urlMapping } = getMessageList(data?.response?.messages, data.response.data.urls);
  const updateURLMapping = [...urlMapping];
  if (data.response.data.urls) {
    data.response.data.urls.forEach((url) => {
      updateURLMapping.push({
        label: url.label.replace(/_URL_TITLE/g, "").toLowerCase().split("_").join(" "),
        url: url.url
      });
    });
  }
  if (data?.response.promo_code_details) {
    if (data?.response.promo_code_details?.is_promo_url_present) {
      updateURLMapping.push({
        url: data?.response?.promo_code_details?.promo_code_url,
        label: data?.response?.promo_code_details?.promo_code_label
      });
    }
  }
  const message = {
    id: util.generateUUID(),
    messageContent: updatedMessageList || messageContent,
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && (showAgent ? getAgentButton() : void 0),
    urlMapping: updateURLMapping,
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};
const handleGetMessageList = (data, token) => {
  let messages = [];
  const msgCount = data.data.messages.length;
  const modifiedData = data.data.messages.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
  modifiedData.forEach((msg, index) => {
    if (msg.role === "user") {
      const message = {
        id: msg.id,
        messageContent: getMessageList([msg.content])?.updatedMessageList,
        type: "user",
        timestamp: new Date(msg.created).getTime(),
        isMessageRead: true,
        senderDisplayName: DISPLAY_NAME.USER,
        showFeedback: false
      };
      messages.push(message);
    } else {
      const transformedData = transformChatbotResponse(
        msg.content_json,
        util.generateUUID(),
        // For retrieved msg, use a new UUID
        new Date(msg.created).getTime() + 1,
        true,
        index !== 0 && index === msgCount - 1
        // ensure that initial message is not marked as last message
      );
      messages = [...messages, ...transformedData];
    }
  });
  const { discussionId, sessionId } = getChatbotSessionInfo(token);
  return { messages, discussionId: discussionId || "", sessionId: sessionId || "" };
};
const handleNonLoggedInOrderTrackingResponse = (data, timestamp, isRetrivedData = false, isLastMessage = false) => {
  const IsIntentRequestCancelation = data.response?.data?.intent === "request cancellation";
  const RequestCancelationText = "Let\u2019s start with your email and order number.\n\nNote: If you placed your order with an account, sign in first. \n\n<ext>Sign in</ext>";
  const message = {
    id: util.generateUUID(),
    messageContent: IsIntentRequestCancelation ? RequestCancelationText : ["Enter your email and order number."],
    type: "chatbot",
    timestamp: timestamp ? new Date(timestamp).getTime() : (/* @__PURE__ */ new Date()).getTime(),
    senderDisplayName: DISPLAY_NAME.CHATBOT,
    isMessageRead: isRetrivedData ? true : false,
    additionalComponents: (!isRetrivedData || isLastMessage) && IsIntentRequestCancelation ? tranferToAgent("nonLoggedInPreChatWithOrderNumber") : !isRetrivedData || isLastMessage ? /* @__PURE__ */ React.createElement(NonLoggedInOrderForm, null) : void 0,
    // urlMapping,
    customMessageType: "orderListMessage",
    showFeedback: isRetrivedData ? false : true
  };
  return message;
};

export { getOrderList, getPrice, handleGetMessageList, handleNonLoggedInOrderTrackingResponse, showAgentButton, transformChatbotResponse };
//# sourceMappingURL=src-utils-chatbot-order-tracking-response-handlers.js.map
